module.exports = __webpack_public_path__ + "static/media/cny.41eb0241.svg";